import each from 'lodash/each'

import { mqSizes } from 'styles/helpers/mq'

import text from '../helpers/text'
import resize from '../helpers/resize'
import { createStore } from '../helpers/state'

const prefix = 'mq'
const initialState = {}
const match = {}

each(mqSizes, (size, k) => {
  const key = prefix + text.capitalize(k)
  initialState[key] = resize.width() < size
  match[key] = size
})

const resizeStore = createStore(initialState)

resize.add({
  resize: () => {
    each(resizeStore, (state, key) => {
      state.set(resize.width() < match[key])
    })
  }
})

export default resizeStore
